export default __webpack_public_path__ + "static/media/hero-1.3ec4c01c.png";